import React from 'react';

const PrivacyPolicy = () => (
  <div className="container py-5">
    <h2>Privacy Policy</h2>
    <p>This is a demo privacy policy page for Lichic. Add your privacy policy here.</p>
  </div>
);

export default PrivacyPolicy;
